import { Alert, Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import React from 'react'
import DefaultModalActions from '../../../../components/GenericModal/DefaultModalActions'
import { ButtonType } from '../../../../components/GenericButton/styles'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

interface ConfirmCloseProjectModalProps {
  handleCloseModal: () => void
  onConfirm: () => void
}

export const ConfirmCloseProjectModal = ({
  handleCloseModal,
  onConfirm
}: ConfirmCloseProjectModalProps): JSX.Element => {
  return (
    <Box>
      <Alert severity='error' icon={<ErrorOutlineIcon />} sx={{ mb: 3 }}>
        <Typography fontWeight='bold' fontSize='0.875rem'>
          All live surveys will be closed immediately.
        </Typography>
      </Alert>

      <Typography variant='body2' fontWeight={500} sx={{ mb: 1 }}>
        Closing this survey project will:
      </Typography>

      <List dense disablePadding sx={{ mb: 2 }}>
        <ListItem disableGutters sx={{ alignItems: 'flex-start', gap: 1 }}>
          <Typography component='span' sx={{ mt: '3px', lineHeight: 1, flexShrink: 0 }}>•</Typography>
          <ListItemText
            primary='Close all live surveys and generate their reports immediately.'
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
        <ListItem disableGutters sx={{ alignItems: 'flex-start', gap: 1 }}>
          <Typography component='span' sx={{ mt: '3px', lineHeight: 1, flexShrink: 0 }}>•</Typography>
          <ListItemText
            primary='Revert any published surveys that have not yet gone live to Draft.'
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </ListItem>
      </List>

      <Typography variant='body2' sx={{ mb: 3 }}>
        Are you sure you want to proceed?
      </Typography>

      <DefaultModalActions
        destructiveButtonProps={{ onClick: handleCloseModal }}
        confirmButtonProps={{
          onClick: onConfirm,
          text: 'Close Project',
          buttonType: ButtonType.Destructive
        }}
      />
    </Box>
  )
}
